import { EntityEnvironment } from "@dinahmoe/dmafjs-core";
import { webAudioContext } from "./webaudio_context";
import { webAudioUtils } from "./webaudio_utils";
import { entities } from "../entities.js";

class NodeMasterHtml extends EntityEnvironment {
  handlers = {
    volume: { handler: this.setVolume, type: "float" },
    muted: { handler: this.setMute, type: "boolean" },
  };

  constructor(name) {
    super(name);
    entities.set(name, this);
  }

  create(dnode) {
    dnode.sources = new Map();
    dnode.input = webAudioContext.context.createGain();
    dnode.mute = webAudioContext.context.createGain();

    dnode.mute.gain.value = dnode.props.muted ? 0 : 1;

    dnode.input.connect(dnode.mute);
    dnode.mute.connect(webAudioContext.context.destination);
    dnode.input.gain.value = webAudioUtils.dbToJs(dnode.props.volume);
  }

  addSource({ dnode, destinationDnode }) {
    dnode.sources.set(destinationDnode.uid, destinationDnode);
  }

  removeSource(dnode) {
    dnode.sources.delete(dnode.uid);
  }

  setVolume(dnode) {
    dnode.input.gain.value = webAudioUtils.dbToJs(dnode.props.volume);
  }

  setMute(dnode) {
    const { muted, fadeTime } = dnode.props;

    const startTime = webAudioContext.context.currentTime;
    const currentValue = dnode.mute.gain.value;
    const endTime = startTime + fadeTime / 1000;

    if (muted) {
      dnode.mute.gain.setValueAtTime(currentValue, startTime);
      dnode.mute.gain.linearRampToValueAtTime(0, endTime);
      return;
    }

    dnode.mute.gain.setValueAtTime(currentValue, startTime);
    dnode.mute.gain.linearRampToValueAtTime(1, endTime);
  }

  destroy(dnode) {
    if (!dnode) return;
    dnode.input?.disconnect();
    dnode.mute?.disconnect();

    for (const source of dnode.sources.values()) {
      source.output?.disconnect();
    }
    dnode.sources.clear();
  }
}

const nodeMaster = new NodeMasterHtml("webaudio:node:master");
export { nodeMaster, NodeMasterHtml };
